import { AnswerButtonDefinition, ANSWER_BUTTON, TEXT } from '../../items';
import { ItemOfType } from './types';

interface AnswerButtonHelperParams {
  group: string | null;
  items?: ItemOfType<'Question'>['items'];
  linkedAudioId?: string;
  llamaSurvey?: boolean | null;
  question?: string;
  correctAnswers?: string[];
  disableButtons?: boolean;
}

/**
 * @returns An array of BUTTON items
 */
export const AnswerButtonHelper = ({
  group,
  items,
  linkedAudioId,
  llamaSurvey,
  question,
  correctAnswers,
  disableButtons
}: AnswerButtonHelperParams) => {
  return (items || []).map(item => {
    return {
      type: ANSWER_BUTTON,
      id: item.id,
      values: {
        answer: item.correct,
        correct: true,
        feedback: item.feedback,
        feedbackAudios: item.feedbackAudios ? item.feedbackAudios[0] : null,
        linkedAudioId,
        group: group || item.id,
        llamaSurvey: llamaSurvey || false,
        question: question,
        text: item.value || '',
        correctAnswers: correctAnswers,
        disableButtons: disableButtons
      },
      items: [
        {
          type: TEXT,
          id: `${item.id}_value`,
          items: [],
          values: {
            value: item.value,
            variant: 'text',
            className: 'pressable'
          }
        }
      ]
    } as AnswerButtonDefinition;
  });
};
